<template>
	<div class="page">
		<pageCart :title="title">
			<div class="content" v-if="data">
				<vHtml v-bind="{markdown: data.content}"/>
			</div>
		</pageCart>
	</div>
</template>

<script>
import pageCart from "@/components/layouts/page/cart.vue";
import vHtml from "@/components/html.vue";

export default {
	components: {pageCart, vHtml},
	data() {
		return {
			data: null
		}
	},
	computed: {
		slug: (t) => t.$route.meta.slug,
		title: (t) => t.data ? t.data.title : null
	},
	methods: {
		async getData() {
			const {data: {data}} = await this.$axios.get(`client/pages/${this.slug}`);
			this.data = data;
		}
	},
	async created() {
		await this.getData();
		this.$store.dispatch("base/meta", {title: this.data.title});
	}
};
</script>

<style lang="scss" scoped>
.page {

}
</style>
